import axios from 'axios';

const API_BASE_URL = import.meta.env.VITE_API_BASE_URL || 'https://backend.buildsupplyco.com/api/v1';

export interface CartItemResponse {
  id: string;
  productId: string;
  variantSku?: string;
  variantId?: string;
  quantity: number;
  price: number;
  product?: any;
  variantInfo?: any;
}

export interface CartApiResponse {
  success: boolean;
  data?: CartItemResponse[];
  message?: string;
}

export class CartApiService {
  private getHeaders() {
    const token = localStorage.getItem('authToken');
    return {
      'Content-Type': 'application/json',
      ...(token && { Authorization: `Bearer ${token}` })
    };
  }

  async getCart(): Promise<CartApiResponse> {
    try {
      const response = await axios.get<CartApiResponse>(`${API_BASE_URL}/cart`, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async addToCart(payload: any): Promise<CartApiResponse> {
    try {
      const response = await axios.post<CartApiResponse>(`${API_BASE_URL}/cart`, payload, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async removeFromCart(productId: string, variantSku?: string, variantId?: string): Promise<CartApiResponse> {
    try {
      const url = `${API_BASE_URL}/cart/${productId}`;
      const config = {
        headers: this.getHeaders(),
        params: {}
      };
      if (variantSku) {
        (config.params as any).variantSku = variantSku;
      }
      if (variantId) {
        (config.params as any).variantId = variantId;
      }
      const response = await axios.delete<CartApiResponse>(url, config);
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async updateQuantity(productId: string, quantity: number, variantSku?: string, variantId?: string): Promise<CartApiResponse> {
    try {
      const body: any = { quantity };
      if (variantSku !== undefined) body.variantSku = variantSku;
      if (variantId !== undefined) body.variantId = variantId;

      const response = await axios.patch<CartApiResponse>(
        `${API_BASE_URL}/cart/${productId}`,
        body,
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async clearCart(): Promise<CartApiResponse> {
    try {
      const response = await axios.delete<CartApiResponse>(`${API_BASE_URL}/cart/empty`, {
        headers: this.getHeaders()
      });
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }

  async mergeCart(guestItems: any[]): Promise<CartApiResponse> {
    try {
      const response = await axios.post<CartApiResponse>(
        `${API_BASE_URL}/cart/merge`,
        { items: guestItems },
        { headers: this.getHeaders() }
      );
      return response.data;
    } catch (error: any) {
      return { success: false, message: error.message };
    }
  }
}

export const cartApiService = new CartApiService();
